<template>
  <Layout1 title="Create your <cloudName> account">
    <template slot="form">
      <p class="col_grey75 fn14 ln_ht20 fw400">I'm signing up as an</p>
      <div class="btn-group" role="group">
        <button
          type="button"
          @click="signupAs='Organization';$validator.reset();clearData()"
          :class="[ signupAs == 'Organization'? 'bg_grey95 text-white': 'bg-white col_grey95']"
          class="signup-tab primary-outline p-2"
        >ORGANISATION</button>
        <button
          type="button"
          @click="signupAs='Individual';$validator.reset();clearData()"
          :class="[ signupAs == 'Individual'? 'bg_grey95 text-white': 'bg-white col_grey95']"
          class="signup-tab primary-outline p-2"
        >INDIVIDUAL</button>
      </div>
      <form class="mt15" @submit.prevent="signup()">
        <div class="row">
          <div class="col-md-12">
            <div class="form-floating mb15" v-if="signupAs == 'Organization'">
              <input
                type="text"
                id="organization"
                placeholder="Organisation *"
                class="form-control fn14"
                name="organization"
                v-model="organization"
                v-validate="{required: true, min: 2, max: 140, regex: /^[A-Z,.\?\+<>;:()*\-&\u0900-\u09630-9A-VXYZÇƏĞİıÖŞÜঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻А-ЯÁČĎÉĚÍŇÓŘŠŤÚŮÝŽÆØÅÄÖÜßΑ-ώÁÉÍÑÓÚÜابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیÅÄÖÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸÀÉÈÌÎÓÒÙÁÉËÏÓÖÜÚÁÉÍÓÖŐÚÜŰĄĆĘŚŁŃÓŻŹÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜА-ЯЁČĆĐŠŽÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔČĆŽŠĐА-ЯЂЈЉЊЋЏก-๙\sÇĞİıÖŞÜА-ЩЬЮЯЄIЇҐіÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸაბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰ٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ'0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+[\u0966-\u097F]*$/i}"
              />
              <label for="organization">Organisation <span class="fs20 col_error">*</span></label>
              <small class="col_error" v-show="errors.has('organization')">{{ errors.first('organization') }}</small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb15">
              <input
                type="text"
                id="firstName"
                placeholder="First Name *"
                class="form-control fn14"
                name="firstName"
                v-model="firstName"
                v-validate="{required: true, min: 2, max: 75, regex: /^[A-Z,.\?\+<>;:()*\-&\u0900-\u09630-9A-VXYZÇƏĞİıÖŞÜঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻А-ЯÁČĎÉĚÍŇÓŘŠŤÚŮÝŽÆØÅÄÖÜßΑ-ώÁÉÍÑÓÚÜابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیÅÄÖÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸÀÉÈÌÎÓÒÙÁÉËÏÓÖÜÚÁÉÍÓÖŐÚÜŰĄĆĘŚŁŃÓŻŹÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜА-ЯЁČĆĐŠŽÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔČĆŽŠĐА-ЯЂЈЉЊЋЏก-๙\sÇĞİıÖŞÜА-ЩЬЮЯЄIЇҐіÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸაბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰ٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ'0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+[\u0966-\u097F]*$/i}"
              />
              <label for="firstName">First Name <span class="fs20 col_error">*</span></label>
              <small class="col_error" v-show="errors.has('firstName')">{{ errors.first('firstName') }}</small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-floating mb15">
              <input
                type="text"
                id="lastName"
                placeholder="Last Name *"
                class="form-control fn14"
                name="lastName"
                v-model="lastName"
                v-validate="{required: true, min: 2, max: 75, regex: /^[A-Z,.\?\+<>;:()*\-&\u0900-\u09630-9A-VXYZÇƏĞİıÖŞÜঀঁংঃঅআইঈউঊঋঌএঐওঔকখগঘঙচছজঝঞটঠডঢণতথদধনপফবভমযরলশষসহ়ঽািীুূৃৄেৈোৌ্ৎৗড়ঢ়য়ৠৡৢৣ০১২৩৪৫৬৭৮৯ৰৱ৲৳৴৵৶৷৸৹৺৻А-ЯÁČĎÉĚÍŇÓŘŠŤÚŮÝŽÆØÅÄÖÜßΑ-ώÁÉÍÑÓÚÜابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیÅÄÖÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸÀÉÈÌÎÓÒÙÁÉËÏÓÖÜÚÁÉÍÓÖŐÚÜŰĄĆĘŚŁŃÓŻŹÃÁÀÂÄÇÉÊËÍÏÕÓÔÖÚÜА-ЯЁČĆĐŠŽÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔČĆŽŠĐА-ЯЂЈЉЊЋЏก-๙\sÇĞİıÖŞÜА-ЩЬЮЯЄIЇҐіÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴĐÈÉẸẺẼÊỀẾỆỂỄÌÍỊỈĨÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠÙÚỤỦŨƯỪỨỰỬỮỲÝỴỶỸაბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰ٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ'0-9آاءأؤئبپتثجچحخدذرزژسشصضطظعغفقکگلمنوهةی۱۲۳۴۵۶۷۸۹۰']+[\u0966-\u097F]*$/i}"
              />
              <label for="lastName">Last Name <span class="fs20 col_error">*</span></label>
              <small class="col_error" v-show="errors.has('lastName')">{{ errors.first('lastName') }}</small>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-floating mb15">
              <input
                type="email"
                id="email"
                placeholder="Email *"
                class="form-control fn14"
                name="email"
                v-model="email"
                v-validate="'required|email'"
              />
              <label for="email">Email <span class="fs20 col_error">*</span></label>
              <small class="col_error" v-show="errors.has('email')">{{ errors.first('email') }}</small>
            </div>
          </div>
          <div class="col-md-12" v-if="reseller">
            <div class="form-floating mb15">
              <input
                type="text"
                id="Reseller"
                placeholder="Reseller"
                class="form-control fn14"
                name="Reseller"
                v-model.trim="resellerCode"
              />
              <label for="Reseller">Reseller <span class="fs20 col_error"></span></label>
              <!-- <small class="col_error" v-show="errors.has('email')">{{ errors.first('email') }}</small> -->
            </div>
          </div>
        </div>
        <div class="wd100">
        <span class="col_grey75 fn14 ln_ht20 fw400">A verification link will be sent to this email</span>
        </div>
        <div class="mt-4 mb-3">
          <div class="dflex align-items-baseline">
            <p class="fn14 ln_ht20 fw400">This account will be created in the currency&nbsp;</p>
            <div class="dropdown fn14">
              <div class="dropdown-toggle col_primary cursor_p" data-bs-toggle="dropdown">
                <span v-if="selectedCurrency">{{ selectedCurrency.currency }} ({{ selectedCurrency.symbol }})</span>
              </div>
              <ul class="dropdown-menu">
                <li v-for="(e, i) in currencyList" :key="i">
                  <a class="dropdown-item" :class="[selectedCurrency.currency == e.currency? 'active' : '']" href="#" @click.prevent="selectedCurrency=e">{{ e.currency }} ({{ e.symbol }})</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-if=!submitted class="mb20 mt20">
          <input type="submit" class="btn btn-apiculus-primary" :value= 'buttonName' />
        </div>
        <button v-if=submitted class="mb20 mt20 btn btn-apiculus-primary" type="button">
          <span class="spinner-border spinner-border-sm text-transform-none" role="status" aria-hidden="true"></span>
          {{ buttonName }}
        </button>
        <p v-if="showPrivacyPolicy || showEULA || showSLA" class="fn14 ln_ht20 fw400 text-transform-none">
          By creating your account, you confirm that you've read and understood the {{cloudName}} 
          <a href="#" v-if="showPrivacyPolicy" class="col_primary" @click.prevent.capture="routeToStaticPage('privacyPolicy')">Privacy Policy</a>
          <span v-if="showPrivacyPolicy && (showEULA || showSLA)">, </span> 
          <a href="#" v-if="showEULA" class="col_primary" @click.prevent.capture="routeToStaticPage('eula')">Terms and Conditions</a> 
          <span v-if="showSLA && showEULA"> and </span> 
          <a href="#" v-if="showSLA" class="col_primary" @click.prevent.capture="routeToStaticPage('sla')">Service Agreement</a>
          <span v-if="showPrivacyPolicy || showEULA || showSLA">.</span>
        </p>
        <span class="fn14 ln_ht20 fw400"><a v-if="showResellerCodeField" href="#" @click="reseller = !reseller" class="col_primary fn14">{{ reseller ? 'Signup without a reseller code' : 'I have a reseller code' }}</a> * <span class="col_grey75 fn14">Already have an account?</span> <router-link class="col_primary fn14" to="/"> Log in</router-link></span>
      </form>
      <vue-recaptcha
        id="recaptcha"
        ref="recaptcha"
        @verify="onCaptchaVerified"
        @expired="onCaptchaExpired"
        :sitekey="siteKey"
        size="invisible">
      </vue-recaptcha>
    </template>
  </Layout1>
</template>

<script>
/* eslint-disable */
import Layout1 from './Layout1.vue'
import VueRecaptcha from 'vue-recaptcha'
import helpers from '../../services/toast-service'

export default {
  name: 'SignUp',
  mixins: [helpers],
  components: {
    Layout1,
    VueRecaptcha
  },
  data () {
    return {
      message: '',
      color: '',
      organization: '',
      firstName: '',
      lastName: '',
      email: '',
      signupAs: 'Organization',
      showPassword: false,
      resellerCode: '',
      reseller: false,
      recaptcha_response: '',
      eulaData: '',
      slaData: '',
      privacyData: '',
      showEULA: true,
      showSLA: true,
      showPrivacyPolicy: true,
      cloudName: '',
      buttonName: 'GET STARTED ON ',
      submitted: false,
      currencyList: [],
      selectedCurrency: ''
    }
  },
  computed: {
    siteKey () {
      return JSON.parse(localStorage.getItem('ApiculusEnv')).siteKey
    },
    showResellerCodeField () {
      return Object.keys(this.$store.state.ApiculusEnv).length && this.$store.state.ApiculusEnv.resellerEnabled
    },
  },
  created () {
    this.$store.dispatch('ACTION_GET_STATIC_PAGE', { directory: 'documents', document_type: 'eula' }).then(res => {
      if (typeof res !== 'object' && res) {
        this.showEULA = true
        this.eulaData = atob(res)
      } else {
        this.showEULA = false
      }
    })
    this.$store.dispatch('ACTION_GET_STATIC_PAGE', {directory: 'documents', document_type: 'sla'}).then(res => {
      if (typeof res !== 'object' && res) {
        this.showSLA = true
        this.slaData = atob(res)
      } else {
        this.showSLA = false
      }
    })
    this.$store.dispatch('ACTION_GET_STATIC_PAGE', {directory: 'documents', document_type: 'privacyPolicy'}).then(res => {
      if (typeof res !== 'object' && res) {
        this.showPrivacyPolicy = true
        this.privacyData = atob(res)
      } else {
        this.showPrivacyPolicy = false
      }
    })
    this.$store.dispatch('ACTION_GET_PROFILE_DETAILS').then(res => {
      if (res) {
        this.cloudName = res.name
        this.buttonName = 'GET STARTED ON ' + this.cloudName
      }
    })

    this.$store.dispatch('ACTION_GET_CURRENCY_LIST')
    .then(res => {
      console.log(res);
      if (res && res.length > 0) {
        this.currencyList = res
        this.selectedCurrency = res.find((e)=>{
          return e.is_base == 1
        })
      }
    })
  },
  methods: {
    routeToStaticPage (page) {
      if (page === 'eula') {
        let newWindow = window.open('', '_blank', 'width=1000,height=800')
        newWindow.document.write(this.eulaData)
        let titleTag = document.createElement('title')
        let textNode = document.createTextNode('Terms & Conditions')
        titleTag.appendChild(textNode)
        newWindow.document.getElementsByTagName('head')[0].appendChild(titleTag)
      } else if (page === 'sla') {
        let newWindow = window.open('', '_blank', 'width=1000,height=800')
        newWindow.document.write(this.slaData)
        let titleTag = document.createElement('title')
        let textNode = document.createTextNode('Service Level Agreements')
        titleTag.appendChild(textNode)
        newWindow.document.getElementsByTagName('head')[0].appendChild(titleTag)
      } else if (page === 'privacyPolicy') {
        let newWindow = window.open('', '_blank', 'width=1000,height=800')
        newWindow.document.write(this.privacyData)
        let titleTag = document.createElement('title')
        let textNode = document.createTextNode(`${this.$tc('privacy', 2)} ${this.$tc('policy', 2)}`)
        titleTag.appendChild(textNode)
        newWindow.document.getElementsByTagName('head')[0].appendChild(titleTag)
      }
    },
    clearData () {
      this.firstName = ''
      this.lastName = '',
      this.organization = ''
      this.email = ''
      this.resellerCode = ''
      this.reseller = false
    },
    initiateRegistration () {
      this.$refs.recaptcha.execute()
    },
    onCaptchaVerified (res) {
      if (res && res.length) {
        this.recaptcha_response = res
        this.signup()
      } else {
        this.toastAlert('Error in verifying the reCAPTCHA', 'error')
      }
    },
    onCaptchaExpired (res) {
      this.recaptcha_response = ''
      this.$refs.recaptcha.reset()
    },
    signup () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let detailObj = {
            fname: this.firstName,
            lname: this.lastName,
            type: this.signupAs.toLowerCase(),
            'g-recaptcha-response': "",
            resellerCode: this.reseller ? this.resellerCode : '',
            email: this.email,
            currency: this.selectedCurrency.currency
          }
          if(this.signupAs.toLowerCase() == 'organization') {
            detailObj.organization_name = this.organization
          }
          this.submitted = true
          this.$store.dispatch('ACTION_INIT_ACCOUNT_V2',detailObj).then(res=>{
            this.submitted = false
            if(res.success) {
              this.$router.push({ path: 'resendVerificationCode', query: {email: this.email} })
            }
            else {
              if(res.error && res.error.message) {
                this.toastAlert(res.error.message, 'error')
              }
              else {
              this.toastAlert('Error in creating account', 'error')
              }
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>

